/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S1_Link_TextInputs */

const tr_servis_s1_link_text = /** @type {(inputs: Servis_S1_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım Koşulları`)
};

const en_servis_s1_link_text = /** @type {(inputs: Servis_S1_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use`)
};

const de_servis_s1_link_text = /** @type {(inputs: Servis_S1_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen`)
};

const ru_servis_s1_link_text = /** @type {(inputs: Servis_S1_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия использования`)
};

/**
* | output |
* | --- |
* | "Terms of Use" |
*
* @param {Servis_S1_Link_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s1_link_text = /** @type {((inputs?: Servis_S1_Link_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S1_Link_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s1_link_text(inputs)
	if (locale === "de") return de_servis_s1_link_text(inputs)
	if (locale === "ru") return ru_servis_s1_link_text(inputs)
	return tr_servis_s1_link_text(inputs)
});